import React from 'react';
import PropTypes from 'prop-types';

import { Micro } from '@vds/typography';
import { isPoBoxAddress } from '../../common/validation';

const AddressLineErrorMsg = ({ addressLine, isEmptyAddress, addressLineError = '' }) => {
  let errorMessage = '';
  const addressLine1 = addressLine?.trim();
  if (addressLine1 === '') {
    errorMessage = addressLineError;
  } else {
    const isPOBox = isPoBoxAddress(addressLine1);
    if (isPOBox) {
      errorMessage = 'We can’t accept a P.O. box for shipping.';
    } else if (isEmptyAddress) {
      errorMessage = 'Address not found. Please try again.';
    }
  }

  if (errorMessage === '') return null;
  return <Micro primitive="p">{errorMessage}</Micro>;
};

AddressLineErrorMsg.propTypes = {
  addressLine: PropTypes.string,
  isEmptyAddress: PropTypes.bool,
  addressLineError: PropTypes.string,
};

export default React.memo(AddressLineErrorMsg);
